<template>
  <div id="adv-search-wrapper">
    <div class="search-content">
      <el-card shadow="hover">
        <div slot="header">
          <h4 style="text-align:left;margin:5px 0;">高级检索</h4>
        </div>
        <!-- 循环输出搜索字段 -->
        <div
          v-for="(keyword,index) in keywords"
          :key="keyword.key"
          class="search-item"
        >
          <!-- 搜索逻辑 -->
          <el-select v-model="keyword.logic" :class="[index === 0 ? 'hide':'','search-field']" style="width:80px;" size="medium">
            <el-option label="并且" value="and" />
            <el-option label="或者" value="or" />
          </el-select>

          <!-- 搜索范围 -->
          <el-select v-model="keyword.field" placeholder="搜索范围" style="width:120px;" size="medium" class="search-field">
            <el-option
              v-for="field in fields"
              :key="field.field"
              :label="field.label"
              :value="field.field"
            />
          </el-select>

          <!-- 输入框 -->
          <el-input
            v-model="keyword.value"
            size="medium"
            class="search-field"
            style="width:300px;"
            placeholder="搜索内容"
            @keyup.enter="search"
          >
            <!-- 加减项 -->
            <el-button slot="append" type="primary" size="small" icon="el-icon-plus" @click="handleAddKeyword" />
            <el-button slot="append" :disabled="index ===0" type="primary" size="small" icon="el-icon-minus" @click="handleRemoveKeyword(index)" />
          </el-input>

        </div>
        <div class="search-btn">
          <el-button type="text" size="medium" icon="el-icon-refresh" plain style="margin-right:20px;" @click="resetKeywords">重置条件</el-button>
          <el-button type="primary" size="medium" icon="el-icon-search" plain @click="search">检索</el-button>
        </div>
      </el-card>
      <Result
        v-show="searched"
        :resource-list="resourceList"
        :total="total"
        @pageNumChanged="handlePageNumChange"
        @pageSizeChanged="handlePageSizeChange"
      />

      <!-- 四个角小方块 -->
      <div class="corner corner1" />
      <div class="corner corner2" />
      <div class="corner corner3" />
      <div class="corner corner4" />
    </div>
  </div>
</template>

<script>
// 接口
import { advSearch } from '@/api/ResourceApi'
import { searchOptions, searchField } from '@/static/config'
import Result from './Result.vue'
export default {
  name: 'AdvSearch',
  components: {
    Result
  },
  data() {
    return {
      searched: false,
      page: 1,
      size: 15,
      resourceList: [],
      total: 0,
      // 可搜索的字段
      fields: searchField,
      keywords: JSON.parse(JSON.stringify(searchOptions))
    }
  },
  methods: {
    /**
     * 开始搜索
     */
    search() {
      // 验证
      for (let index = 0; index < this.keywords.length; index++) {
        const k = this.keywords[index]
        if (k.field === '' && k.value !== '') {
          this.$message({
            type: 'info',
            message: `请选择${k.value}搜索范围`,
            offset: '174'
          })
          return false
        }

        if (k.field !== '' && k.value === '') {
          const label = this.fields.find(f => f.field === k.field)['label']
          this.$message({
            type: 'info',
            message: `请输入${label}搜索内容`,
            offset: '174'
          })
          return false
        }
      }

      // 开始搜索
      this.doSearch()
    },

    doSearch() {
      advSearch(this.keywords, this.page, this.size)
        .then(resp => {
          this.searched = true
          this.resourceList = resp.data.list
          this.total = resp.data.total
        })
    },

    /**
     * 处理添加选项
     */
    handleAddKeyword() {
      this.keywords.push({ field: '', value: '', logic: 'and', key: Math.random() })
    },

    /**
     * 处理减小选项
     */
    handleRemoveKeyword(index) {
      this.keywords.splice(index, 1)
    },

    resetKeywords() {
      this.keywords = JSON.parse(JSON.stringify(searchOptions))
      this.resourceList = []
      this.total = 0
    },

    handlePageNumChange(pageNum) {
      this.page = pageNum
      this.$nextTick(() => {
        this.doSearch()
        window.scrollTo({
          top: 135,
          behavior: 'smooth'
        })
      })
    },

    handlePageSizeChange(pageSize) {
      this.size = pageSize
      this.doSearch()
    }
  }

}
</script>

<style lang="scss" scoped>
#adv-search-wrapper{
  width: 1200px;
  margin: 0 auto;
  background: url(../../assets/imgs/block-bg.png);
  padding: 9px;
  border: 1px solid #d5d5d4;
  min-height: 800px;
  margin-bottom: 30px;
  position: relative;
  left: 0px;
  top: 0px;
  // 四个角方块
  .corner {
    width: 12px;
    height: 12px;
    border: 1px solid #d5d5d4;
    position: absolute;
  }
  // 方块1
  .corner1 {
    top: -6px;
    left: -6px;
  }
  // 方块2
  .corner2 {
    top: -6px;
    right: -6px;
  }
  // 方块3
  .corner3 {
    bottom: -6px;
    left: -6px;
  }
  // 方块4
  .corner4 {
    right: -6px;
    bottom: -6px;
  }
}

.search-content{
  padding: 10px;
  background-color: #fff;
}

.search-item{
  margin-bottom: 10px;
  float:left;
  width: 100%;
}
.search-field{
  float: left;
  margin: 0 5px;
}

.hide{
  visibility: hidden;
}

.search-btn{
  clear:both;
  text-align:left;
  padding-left:200px;
  margin-top:100px;
}
</style>
